// extracted by css-extract-rspack-plugin
export default {"commitHashWrapper":"Commits-module__commitHashWrapper__TpXR4","copyButton":"Commits-module__copyButton__dCRnE"};